import { log } from 'log';
import { pick } from 'ramda';
import { useCallback } from 'react';
import { post } from 'js/utils/fetch.util';
import { IGame } from 'js/hooks/games/types';
import { getCookie } from 'js/utils/cookie.util';
import { COOKIE_NAME } from 'js/utils/affiliate.util';
import { useAppSelector, useUserSelector, useDeviceSelector } from 'js/store/hooks';

import * as Types from './types';

export const useGetPggGames = () => {
    const { pgg2: { casino, endpointUrl }, clientType } = useAppSelector(pick(['pgg2', 'clientType']));
    const { clientPlatform, deliveryPlatform } = useDeviceSelector(pick(['clientPlatform', 'deliveryPlatform']));
    const { userDetails, country, pasSessionToken } = useUserSelector(pick(['userDetails', 'country', 'pasSessionToken']));

    return useCallback(async ({ pggCategoryName, maxGames, categoryName, allGames }:
        {
            maxGames: string;
            categoryName: string;
            pggCategoryName: string;
            allGames: { [key: string]: IGame };
        }) => {
        const emptyResponse = {
            categoryName,
            pggCategoryName,
            pggBecauseYouPlayedGameName: '',
            games: []
        };

        if (!endpointUrl) {
            return emptyResponse;
        }

        const { age, sex, username, userId, advertiser } = userDetails || {};

        const affiliate = advertiser || getCookie(COOKIE_NAME);
        /* eslint-disable camelcase */
        const requestBody = {
            brand: casino,
            client_type: clientType,
            client_platform: clientPlatform,
            client_delivery_platform: deliveryPlatform,
            content_type: '',
            session_id: pasSessionToken,
            max_games: Number(maxGames),
            category_names: [pggCategoryName],
            ...age ? { age } : {},
            ...username ? { username } : {},
            ...affiliate ? { affiliate } : {},
            ...userId ? { userid: userId } : {},
            ...sex ? { gender: sex.toLowerCase() } : {},
            ...country !== 'XX' && { country_code: country }
        };
        /* eslint-enable camelcase */

        const requestOptions = {
            referrerPolicy: 'no-referrer-when-downgrade',
            referrer: window.location.origin + window.location.pathname,
            requestTimeout: 3000
        };

        try {
            const data = await post({ url: `${endpointUrl}/categories`, requestBody, requestOptions }) as Types.IPggCategoriesResponse;
            const pggGameCode = data.categories?.[0]?.game_code;
            const pggBecauseYouPlayedGameName = pggGameCode ? allGames[pggGameCode]?.name : undefined;

            if (data.group === 'control') {
                log('log', `[Games Grid] BI category has "group = 'control'". BI category - ${categoryName}`);

                return emptyResponse;
            }

            return {
                categoryName,
                pggCategoryName,
                pggBecauseYouPlayedGameName,
                games: data.categories?.[0]?.games.filter((gameCode: string) => {
                    return allGames[gameCode] && !allGames[gameCode].isExcludedFromPGG;
                }) as string[] || []
            };
        } catch (error) {
            log('error', `[Games Grid] unable to get games from PGG. BI category ${categoryName}`, error);

            return emptyResponse;
        }

    }, [casino, clientPlatform, clientType, country, deliveryPlatform, endpointUrl, pasSessionToken, userDetails]);
};
